export enum ImageTypeEnum {
    JPEG = 'image/jpeg',
    PNG = 'image/png'
}
